var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXRounded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.205 4.63376C24.265 3.57372 24.265 1.85506 23.205 0.795027C22.1449 -0.265009 20.4263 -0.265009 19.3662 0.795027L12.0001 8.16121L4.63387 0.795027C3.57384 -0.265009 1.85518 -0.265009 0.795142 0.795027C-0.264895 1.85506 -0.264895 3.57372 0.795142 4.63376L8.16133 11.9999L0.795027 19.3662C-0.265009 20.4263 -0.265009 22.1449 0.795027 23.205C1.85506 24.265 3.57372 24.265 4.63376 23.205L12.0001 15.8387L19.3664 23.205C20.4264 24.265 22.1451 24.265 23.2051 23.205C24.2651 22.1449 24.2651 20.4263 23.2051 19.3662L15.8388 11.9999L23.205 4.63376Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXRounded);
export default __webpack_public_path__ + "static/media/x_rounded.791e59ac2095b0226490420d835d70a4.svg";
export { ForwardRef as ReactComponent };